module.exports = __webpack_public_path__ + "static/media/economic-growth.1078f298.svg";